/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortedHeader } from "components/Datatable/components/SortedHeader";
import { useNsuRegisterFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";

export default function SortedCell({
  ...props
}: {
  title: string;
  column: any;
  orderName?: any;
}) {
  const { updateFilter } = useNsuRegisterFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const {
    order,
  } = filters;

  const handleOrderChange = (value: {
    [key: string | number]: string;
  }) => {
    updateFilter({ key: "order", value });
  };

  return <SortedHeader {...props} setOrder={handleOrderChange} sortedState={order}/>;
}
